import { useState } from "react";
import { draftToNumber } from "../../TradeForm/utils/format";
import { applyKeypadKey } from "../utils/keypad";

const formatWithDecimals = (value) => Number(value).toFixed(2);

export const useWagerKeypad = ({ wager, onWagerChange }) => {
  const [draft, setDraft] = useState(formatWithDecimals(wager));
  // Armed on open: the first digit or "." replaces the whole value
  const [isOvertype, setIsOvertype] = useState(true);

  const onKeyPress = (key) => {
    const next = applyKeypadKey(draft, key, { isOvertype });

    setIsOvertype(false);
    setDraft(next);
    onWagerChange(draftToNumber(next));
  };

  return { draft, onKeyPress };
};
